import styled from "styled-components";
import { color, spacing } from "@conserveit/blocks";

const $Wrapper = styled.div`
  position: relative;
`;

const $MenuWrapper = styled.div`
  display: inline-flex;
  flex: 1;
  justify-content: flex-end;
  margin-right: ${spacing.extraLoose};
`;

const $Avatar = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 100%;
  height: 48px;
  width: 48px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: ${color.pureWhite};
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
`;

export { $Wrapper, $MenuWrapper, $Avatar };
